import { create } from 'zustand';
const resultValues={
  isMobile:window.innerWidth < 768,
};
const useResponsiveStore = create((set) => ({
  responsiveData: { ...resultValues },
  setResponsiveData: (newFormData) =>
    set((state) => ({
      responsiveData: { ...state.previewData, ...newFormData },
    })),
}));

export default useResponsiveStore;
